module.exports = __webpack_public_path__ + "static/media/IMG_4489.521b1fa9.jpg";